import { CircularProgress } from "@mui/material";
import { CSSProperties, MouseEventHandler } from "react";
import "./style.css";

interface ButtonProps {
  title: string;
  leftIconPath?: string;
  onClickLeftIcon?: MouseEventHandler;
  onClickRightIcon?: MouseEventHandler;
  rightIconPath?: string;
  className?: string;
  titleClassName?: string;
  containerStyle?: CSSProperties;
  rightIconStyle?: CSSProperties;
  onClick?: MouseEventHandler;
  isLoading?: boolean;
  disabled?: boolean;
  rightIconBGVisibility?: boolean;
  leftIconBGVisibility?: boolean;
  variant: "primary" | "secondary";
  type?: "submit" | "reset" | "button" | undefined;
  autoFocus?: boolean;
  titleStyle?: CSSProperties;
}

const Button = ({
  title,
  leftIconPath,
  onClickLeftIcon,
  rightIconPath,
  onClickRightIcon,
  containerStyle,
  onClick,
  className,
  titleClassName,
  rightIconStyle,
  isLoading,
  disabled,
  rightIconBGVisibility,
  leftIconBGVisibility,
  variant,
  type,
  autoFocus,
  titleStyle,
}: ButtonProps) => {
  const addClassName = () => {
    if (leftIconBGVisibility) {
      if (variant === "secondary") {
        return "leftBackGroundSecondary";
      }
      if (variant === "primary") {
        return "leftIconBackGround";
      }
    }
    if (rightIconBGVisibility) {
      if (variant === "secondary") {
        return "RightBackGroundSecondary";
      }
      if (variant === "primary") {
        return "RightBackGround";
      }
    }
  };

  return (
    <div
      className={`buttonContainer unselectable clickable ${className} ${
        variant === "secondary" ? "buttonSecondaryContainer" : ""
      }`}
      style={{
        ...containerStyle,
      }}
      onClick={onClick}
      role="button"
      id="customButton"
    >
      {isLoading && (
        <CircularProgress
          size={20}
          sx={{
            color: variant === "primary" ? "#fff" : "#000",
            position: "absolute",
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            margin: "auto",
          }}
        />
      )}
      {leftIconPath && (
        <div
          className={`buttonLeftIconContainer ${
            isLoading ? "hideElement" : ""
          } ${addClassName()}`}
          onClick={onClickLeftIcon}
        >
          <img src={leftIconPath} alt="leftIcon" className="buttonLeftIcon" />
        </div>
      )}
      <button
        name="button"
        type={type || "button"}
        className={`commonButton ${titleClassName} ${
          isLoading ? "hideElement" : ""
        } ${variant === "secondary" ? "commonButtonSecondary" : ""}`}
        disabled={disabled || isLoading}
        style={{
          width: !leftIconPath && !rightIconPath ? "100%" : "auto",
          ...titleStyle,
        }}
        autoFocus={autoFocus}
      >
        {title}
      </button>
      {rightIconPath && (
        <div
          className={`buttonRightIconContainer ${
            isLoading ? "hideElement" : ""
          } ${addClassName()}`}
          style={{ ...rightIconStyle }}
          onClick={onClickRightIcon}
        >
          <img
            src={rightIconPath}
            alt="rightIcon"
            className="buttonRightIcon"
          />
        </div>
      )}
    </div>
  );
};

export default Button;
